import { Separator } from '@talentmesh/ui/components/separator';
import TestInfo from '../../../../../../../../../Models/TestInfo';
import { getTopicsDescriptionHeaderByTestType } from '../../../../../../../../../Utils/RecommendationStepUtils';
import BaseTestCardsConstants from './BaseTestCardConstants';
import BaseTestCardTagItem from './BaseTestCardTagItem';

export type BaseTestCardTagCloudProps = Pick<TestInfo, 'testType' | 'topics' | 'totalTopicsCount'>;

function BaseTestCardTagCloud({ topics, totalTopicsCount, testType }: BaseTestCardTagCloudProps) {
    return (
        <div className="flex flex-col gap-2.5 px-1.5">
            <div className="text-foreground flex max-h-10 min-h-10 items-center text-xs font-bold tracking-wide">
                {getTopicsDescriptionHeaderByTestType(totalTopicsCount, testType)}
            </div>

            <Separator />

            <div className="flex flex-col content-start justify-between gap-1">
                {topics.slice(0, BaseTestCardsConstants.MaxTagCount).map((item) => (
                    <BaseTestCardTagItem key={item} label={item} />
                ))}
            </div>
        </div>
    );
}

export default BaseTestCardTagCloud;
